// This file was automatically generated from print.headerPreview.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.headerPreview');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.practices');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.headerPreview.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.data.practices.customHeader({header: el8Globals.PRINT_HEADER}, output);
  output.append('<div class="letterBody"><table class="letterOpening" width="100%" border="0" cellspacing="0" cellpadding="0"><tr><td class="pt20" width="100%">Dr. Test<br>123 Elation Way, San Francisco, CA 94114<br>Office: 555-555-5555<br>Fax: 555-555-5555</td></tr><tr><td class="el8Bold pt10" width="100%">Re: Sample Demo Patient (DOB: 01/01/1970)</td></tr><tr><td class="el8Bold pt10" width="100%">Subject: <span class="el8Bold">Preview custom print header</span></td></tr></table><p class="el8Preserve">\nThis page shows a preview of your custom header shown on a Provider Letter. \n\nIf you are using an image-based header, here are some helpful tips:\n\n  1. The recommended image size is between 80 and 400 pixels tall, and up to 2464 pixels wide.\n\n  2. Choose "left align", "right align", or "center align" to avoid blurring due to image scaling.\n\n  3. If there is text in your image, use a much larger font size than you normally would (e.g. 36-72pt). This is because printers have a higher resolution than most computer screens.\n\n  4. The PNG image format is recommended for text and logos; avoid JPG/JPEG and GIF if possible.\n\n  5. Use bold colors and avoid color gradients for best results when scanning and copying.\n</p></div></div>');
  if (!opt_sb) return output.toString();
};
